// extracted by mini-css-extract-plugin
export default {"form":"AddUser_form__1z3c6"};